export const supportedLangSet = ['en', 'de', 'sk', 'hr', 'hu', 'cs', 'tr', 'it', 'pl', 'es', 'ro', 'rs', 'sl', 'lt', 'lv', 'pt','uk','ko','fr','bg','mk'];